import React, { useState } from "react";
import { removeDevice } from "../utils/deviceManager";

const S = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.7)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 3000,
    padding: "20px",
  },
  panel: {
    background: "white",
    width: "100%",
    maxWidth: "440px",
    borderRadius: "16px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    direction: "rtl",
  },
  header: {
    background: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
    padding: "16px 20px",
    color: "white",
    fontSize: "16px",
    fontWeight: 600,
  },
  body: {
    padding: "24px",
  },
  message: {
    fontSize: "14px",
    color: "#475569",
    lineHeight: 1.6,
    marginBottom: "16px",
  },
  deviceCard: {
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "12px",
    marginBottom: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deviceInfo: {
    fontSize: "13px",
    color: "#334155",
  },
  deviceTime: {
    fontSize: "11px",
    color: "#94a3b8",
    marginTop: "2px",
  },
  removeBtn: {
    padding: "4px 10px",
    background: "#fee2e2",
    color: "#dc2626",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
  },
  btnRow: {
    display: "flex",
    gap: "8px",
    marginTop: "16px",
  },
  btnPrimary: {
    padding: "8px 16px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    flex: 1,
  },
  btnSecondary: {
    padding: "8px 16px",
    background: "#e2e8f0",
    color: "#334155",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  },
  activeDot: {
    display: "inline-block",
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#22c55e",
    marginLeft: "6px",
  },
};

export default function DeviceBlockedModal({ reason, activeDevice, devices, maxDevices, onRetry, onSignOut }) {
  const [removing, setRemoving] = useState(null);

  const handleRemove = async (deviceId) => {
    setRemoving(deviceId);
    await removeDevice(deviceId);
    onRetry();
  };

  if (reason === 'concurrent') {
    const secsAgo = activeDevice
      ? Math.round((Date.now() - new Date(activeDevice.last_active_at).getTime()) / 1000)
      : null;
    const isActive = secsAgo != null && secsAgo < 45;

    return (
      <div style={S.overlay}>
        <div style={S.panel}>
          <div style={S.header}>החשבון בשימוש במכשיר אחר</div>
          <div style={S.body}>
            <div style={S.message}>
              {isActive
                ? 'החשבון פעיל כרגע במכשיר אחר. סגור אותו שם ולחץ "נסה שוב", או לחץ "נתק מכשיר קודם" כדי להיכנס כאן.'
                : 'המכשיר האחר לא פעיל — לחץ "נתק מכשיר קודם" כדי להיכנס.'}
            </div>
            {activeDevice && (
              <div style={S.deviceCard}>
                <div>
                  <div style={S.deviceInfo}>
                    {activeDevice.device_name}
                    <span style={{ ...S.activeDot, background: isActive ? '#22c55e' : '#94a3b8' }} />
                  </div>
                  <div style={S.deviceTime}>
                    {secsAgo != null
                      ? `פעיל לאחרונה לפני ${secsAgo < 60 ? `${secsAgo} שניות` : `${Math.round(secsAgo / 60)} דקות`}`
                      : 'זמן לא ידוע'}
                  </div>
                </div>
                <button
                  style={{ ...S.removeBtn, opacity: removing === activeDevice.device_id ? 0.5 : 1 }}
                  onClick={() => handleRemove(activeDevice.device_id)}
                  disabled={removing === activeDevice.device_id}
                >
                  {removing === activeDevice.device_id ? '...' : 'נתק'}
                </button>
              </div>
            )}
            <div style={S.btnRow}>
              <button style={S.btnPrimary} onClick={onRetry}>נסה שוב</button>
              <button
                style={{ ...S.btnPrimary, background: '#dc2626' }}
                onClick={() => activeDevice && handleRemove(activeDevice.device_id)}
                disabled={!activeDevice || removing === activeDevice?.device_id}
              >
                נתק מכשיר קודם
              </button>
              <button style={S.btnSecondary} onClick={onSignOut}>התנתקות</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (reason === 'max_devices') {
    return (
      <div style={S.overlay}>
        <div style={S.panel}>
          <div style={{ ...S.header, background: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)" }}>
            הגעת למגבלת המכשירים ({maxDevices})
          </div>
          <div style={S.body}>
            <div style={S.message}>
              הסר מכשיר קיים כדי להתחבר מהמכשיר הנוכחי.
            </div>
            {(devices || []).map(d => (
              <div key={d.device_id} style={S.deviceCard}>
                <div>
                  <div style={S.deviceInfo}>{d.device_name}</div>
                  <div style={S.deviceTime}>
                    נרשם: {new Date(d.created_at).toLocaleDateString('he-IL')}
                  </div>
                </div>
                <button
                  style={{ ...S.removeBtn, opacity: removing === d.device_id ? 0.5 : 1 }}
                  onClick={() => handleRemove(d.device_id)}
                  disabled={removing === d.device_id}
                >
                  {removing === d.device_id ? '...' : 'הסר'}
                </button>
              </div>
            ))}
            <div style={S.btnRow}>
              <button style={S.btnSecondary} onClick={onSignOut}>התנתקות</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
